<template>
  <div class="animated container">
    <div class="row justify-content-center">
      <div class="col-md-4 text-center">
        <div class="card">
          <div class="card-header">
            Přihlášení
          </div>
          <div class="card-body">
          <!--<router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeReception' }">Recepce</router-link>
            <router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeDoctor', params: { doctorid: 1 }}">Přihlášení doktora 1</router-link>
            <router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeDoctor', params: { doctorid: 2 }}">Přihlášení doktora 2</router-link>-->
            <form @submit.prevent="submitLoginForm">
              <div class="form-group">
                <label for="exampleInputEmail1">Uživatelské jméno</label>
                <input v-model="user.username" type="text" class="form-control" id="exampleInputEmail1" data-testid="login-username" placeholder="Uživatelské jméno">
                <small id="usernameError" class="form-text text-danger" v-if="loginError">{{ loginError.username }}</small>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Heslo</label>
                <input v-model="user.password" type="password" class="form-control" id="exampleInputPassword1" data-testid="login-password" placeholder="Heslo">
                <small id="passwordError" class="form-text text-danger" v-if="loginError">{{ loginError.password }}</small>
              </div>
              <div class="form-group" v-if="pinExpTime !== false">
              <!--<div class="form-group">-->
                <label for="inputPIN_0">PIN</label>
                <div class="row justify-content-between m-0">
                  <input v-model="user.pin_0" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(0, $event)" @click="selectAll(0)" @keyup="writePIN(0, $event)" autofocus id="inputPIN_0" data-testid="login-pin-0" placeholder="">
                  <input v-model="user.pin_1" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(1, $event)" @click="selectAll(1)" @keyup="writePIN(1, $event)" id="inputPIN_1" data-testid="login-pin-1" placeholder="">
                  <input v-model="user.pin_2" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(2, $event)" @click="selectAll(2)" @keyup="writePIN(2, $event)" id="inputPIN_2" data-testid="login-pin-2" placeholder="">
                  <input v-model="user.pin_3" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(3, $event)" @click="selectAll(3)" @keyup="writePIN(3, $event)" id="inputPIN_3" data-testid="login-pin-3" placeholder="">
                  <input v-model="user.pin_4" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(4, $event)" @click="selectAll(4)" @keyup="writePIN(4, $event)" id="inputPIN_4" data-testid="login-pin-4" placeholder="">
                </div>
                <small id="pinError" class="form-text text-danger" v-if="loginError">{{ loginError.pin }}</small>
                <small id="pinError" class="form-text text-danger" v-if="pinExpTime">{{ pinRemainingTime }}</small>
              </div>
              <!-- <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input">
                  Check me out
                </label>
              </div>-->
              <button type="submit" id="submitLogin" data-testid="login-submit" class="btn btn-primary">Přihlásit se</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios'

  export default {
    name: 'dashboard',
    data () {
      return {
        user: {
          pin_0: '',
          pin_1: '',
          pin_2: '',
          pin_3: '',
          pin_4: ''
        },
        prihlasen: '',
        login: false,
        loginDone: false,
        loginError: false,
        loginPending: false,
        pinExpTime: false,
        pinExpired: false,
        remainingPINTime: null
        // pinRemainingTime: false
      }
    },
    methods: {
      test () {
        this.pinExpTime = true
      },
      postLogin (params) {
        this.loginPending = true
        this.$http.post('login2', params, {emulateJSON: true}).then(response => {
          // console.log(response)
          if (response.data.error) {
            if (response.data.error.pin_exp_time) {
              // this.calcPINRemainingTime(response.data.error.pin_exp_time)
              this.pinExpTime = response.data.error.pin_exp_time
            }
          } else if (response.data.auth) {
            this.$ls.set('fullname', response.data.auth.fullname)
            this.$ls.set('authenticated', !!response.data.auth)
            this.$ls.set('role', JSON.stringify(response.data.auth.role))
            this.$ls.set('userid', response.data.auth.id)
            // this.$ls.set('token_exp_ms', response.data.auth.token_exp_time)

            // this.$nextTick(function () {
            this.loginPending = false
            this.loginDone = true
            // })
          }
        }).catch(error => {
          if (error.response.data.error.pin_exp_time) {
            this.pinExpTime = error.response.data.error.pin_exp_time
          }
          this.loginError = error.response.data.errors
          this.loginPending = false
        })
      },
      submitLoginForm () {
        let params = {
          username: this.user.username,
          password: this.user.password,
          pin: this.user.pin_0 + '' + this.user.pin_1 + '' + this.user.pin_2 + '' + this.user.pin_3 + '' + this.user.pin_4
        }
        this.postLogin(params)
        // this.authLogin({params: {}, data: {username: this.user.username, password: this.user.password}})
      },
      deletePIN (index, event) {
        if (index > 0 && event.target.value.length < 1) {
          // console.log('inputPIN_' + (index - 1))
          let input = document.getElementById('inputPIN_' + (index - 1))
          input.focus()
          input.setSelectionRange(0, input.value.length)
        }
      },
      writePIN (index, event) {
        // console.log(event)
        if (event.key === 'Tab') {
          let input = document.getElementById('inputPIN_' + (index + 1))
          // input.focus()
          input.setSelectionRange(0, input.value.length)
        } else if (event.target.value.length > 0 && ((event.key >= 1 && event.key <= 9) || event.key === '0')) {
          if (index < 4) {
            let input = document.getElementById('inputPIN_' + (index + 1))
            input.focus()
            input.setSelectionRange(0, input.value.length)
          } else {
            document.getElementById('submitLogin').focus()
          }
        } else {
          event.target.value = ''
        }
      },
      selectAll (index) {
        let input = document.getElementById('inputPIN_' + index)
        input.setSelectionRange(0, input.value.length)
      },
      redirectIfLoggedIn (val, oldVal, uri) {
        if (val === true) {
          this.$router.push({name: 'Home'})
        }
      }
    },
    computed: {
      pinRemainingTime () {
        this.intervalid1 = setInterval(function () {
          let now = new Date().getTime()
          let pinTimeTo = this.$moment(this.pinExpTime, 'DD.MM.YYYY HH:mm:ss').toDate().getTime()
          let distance = pinTimeTo - now
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
          let seconds = Math.floor((distance % (1000 * 60)) / 1000)
          if (distance < 1) {
            this.pinExpired = true
          } else {
            this.remainingPINTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds)
          }
        }.bind(this), 1000)

        return this.remainingPINTime
      }
    },
    watch: {
      loginDone (val) {
        if (val === true) {
          this.$router.push({ name: 'Home' })
        }
      },
      'user.pin_0' (val) {
        if (isNaN(val)) {
          this.user.pin_0 = ''
        }
      },
      'user.pin_1' (val) {
        if (isNaN(val)) {
          this.user.pin_1 = ''
        }
      },
      'user.pin_2' (val) {
        if (isNaN(val)) {
          this.user.pin_2 = ''
        }
      },
      'user.pin_3' (val) {
        if (isNaN(val)) {
          this.user.pin_3 = ''
        }
      },
      'user.pin_4' (val) {
        if (isNaN(val)) {
          this.user.pin_4 = ''
        }
      }
      /* pinExpTime (val) {
        if (val !== false) {
          document.getElementById('inputPIN_1').focus()
        }
      } */
    },
    mounted () {
      // console.log(this.$route)
      this.$ls.on('authenticated', this.redirectIfLoggedIn)
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Login2.vue?7e3bc7aa